import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { ARTICLE_BLOG_LIST, ARTICLE_COOP_LIST } from '../utils/articlePaths';

export default function ArticlesNav({ language = 'fr', newTab = false }) {
  const isAr = language === 'ar';
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const tabProps = newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {};

  const copy = isAr
    ? {
        trigger: 'المقالات',
        blogTitle: 'المدونة',
        blogDesc: 'أدلة ونصائح وأخبار لرقمنة تعاونيتكم في المغرب.',
        coopTitle: 'تعرّفوا على تعاونياتنا',
        coopDesc: 'قصص، رسائل ومسارات التعاونيات في شبكة تعاونيتي.',
      }
    : {
        trigger: 'Articles',
        blogTitle: 'Blog',
        blogDesc: 'Guides, conseils et actualités pour digitaliser votre coopérative.',
        coopTitle: 'Rencontrez nos coopératives',
        coopDesc: 'Portraits, histoires et missions des coopératives du réseau Taaouniaty.',
      };

  useEffect(() => {
    const onDoc = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  return (
    <div
      className={`nav-articles${open ? ' is-open' : ''}`}
      ref={wrapRef}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <Link
        to={ARTICLE_BLOG_LIST}
        className="nav-articles__trigger"
        aria-expanded={open}
        aria-haspopup="true"
        onClick={() => setOpen(false)}
        {...tabProps}
      >
        {copy.trigger}
        <ChevronDown size={14} />
      </Link>
      <div className="nav-articles__panel" role="menu">
        <div className="nav-articles__panel-inner">
        <Link to={ARTICLE_BLOG_LIST} className="nav-articles__item" role="menuitem" onClick={() => setOpen(false)} {...tabProps}>
          <strong>{copy.blogTitle}</strong>
          <span>{copy.blogDesc}</span>
        </Link>
        <Link to={ARTICLE_COOP_LIST} className="nav-articles__item" role="menuitem" onClick={() => setOpen(false)} {...tabProps}>
          <strong>{copy.coopTitle}</strong>
          <span>{copy.coopDesc}</span>
        </Link>
        </div>
      </div>
    </div>
  );
}
